import moment from 'moment';
import { DEFAULT, TWO_DIGIT_STANDARD_DATE, TWO_DIGIT_STANDARD_DATE_AND_TIME_12_HOUR, STANDARD_DATE, MONTH_DAY, MONTH_YEAR, DAY, ISO_8601_DATE_ONLY, WEEKDAY_MONTH_DAY_YEAR, YEAR_MONTH, WEEKDAY_MONTH_DAY } from '../constants/date-formats';
export const getDateInUtc = (date, fromFormat) => moment.utc(date, fromFormat);
export const formatDateUtc = format => (date, fromFormat) => date ? getDateInUtc(date, fromFormat).format(format) : '';
const formatDateDefault = formatDateUtc(DEFAULT);
export default formatDateDefault;
export const format2DigitStandardDate = formatDateUtc(TWO_DIGIT_STANDARD_DATE);
export const format2DigitStandardDateAnd12HourTime = formatDateUtc(TWO_DIGIT_STANDARD_DATE_AND_TIME_12_HOUR);
export const formatStandardDate = formatDateUtc(STANDARD_DATE);
export const formatMonthDay = formatDateUtc(MONTH_DAY);
export const formatMonthYear = formatDateUtc(MONTH_YEAR);
export const formatDay = formatDateUtc(DAY);
export const formatWeekdayMonthYear = formatDateUtc(WEEKDAY_MONTH_DAY_YEAR);
export const formatYearMonth = formatDateUtc(YEAR_MONTH);
export const formatISO8601DateOnly = formatDateUtc(ISO_8601_DATE_ONLY);
export const formatWeekdayMonthDay = formatDateUtc(WEEKDAY_MONTH_DAY);